import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  color: 'inherit',
}));

const LogoImage = styled('img')(({ theme }) => ({
  height: '50px',
  width: 'auto',
  objectFit: 'contain',
  maxWidth: '200px',
  display: 'block',
  [theme.breakpoints.down('md')]: {
    height: '40px',
  },
}));

const FallbackText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.5rem',
  color: '#3c005a',
  letterSpacing: '0.5px',
}));

const Logo = () => {
  const [imageError, setImageError] = React.useState(false);
  
  // Path to logo in public folder
  const logoPath = `${process.env.PUBLIC_URL || ''}/thrana.svg`;
  
  return (
    <LogoContainer>
      {!imageError ? (
        <LogoImage 
          src={logoPath}
          alt="Thrana Logo"
          onError={() => {
            console.error(`Logo failed to load from: ${logoPath}`);
            console.error('Please ensure thrana.svg exists in the public folder at: /public/thrana.svg');
            setImageError(true);
          }}
        />
      ) : (
        <FallbackText variant="h6">Thrana</FallbackText>
      )}
    </LogoContainer>
  );
};

export default Logo; 